import {Component, OnInit} from '@angular/core';
import {TokenPayload, UserService} from "../services/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {RoutingstateService} from "../services/routingstate.service";
import {NotificationsService} from "angular2-notifications";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {AssetsService} from "../services/assets.service";
import {AdminService} from "../services/admin.service";
import {Globals} from "../app-globals";
import {ExchangeService} from "../services/exchange.service";

@Component({
    selector: 'app-applogin',
    templateUrl: './applogin.component.html',
    styleUrls: ['./applogin.component.css']
})
export class ApploginComponent implements OnInit {
    hide: boolean = true;
    adminLogin: TokenPayload = {
        email: '',
        password: '',
        authflag: true,
        _csrf: null
    };

    previousRoute: string;
    verificationstr = '';

    constructor(private userService: UserService,
                private router: Router,
                private routingState: RoutingstateService,
                private  notifSer: NotificationsService,
                private spinnerService: Ng4LoadingSpinnerService,
                private assetsService: AssetsService,
                private adminService: AdminService,
                private actroute: ActivatedRoute,
                private exchageService: ExchangeService,
                private global: Globals) {
    }
    showPassword = false;

    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    }
    ngOnInit() {
        if (this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/home');
        } else {
            this.verificationstr = this.actroute.snapshot.paramMap.get('str');
            if (this.verificationstr) {
                this.verifyemail(this.verificationstr);
            }
            this.csrf();
            this.previousRoute = this.routingState.getPreviousUrl();
            if (this.userService.isLoggedIn()) {
                this.router.navigateByUrl(this.previousRoute);
            }
        }
    }
    verifyemail(str) {
        this.exchageService.getEmailVerified(str).subscribe((result) => {
            this.notifSer.success(
                'Success',
                result.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }

            )
            this.router.navigateByUrl('/index');
        }, (err) => {
            // if (err.error.message == 'Link Expired') {
            //     this.expiredlink = true;
            // }
            this.notifSer.error(
                'Error',
                err.error.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }

            )
        })
    }
    login() {
        this.spinnerService.show();
        this.userService.csrf().subscribe((response) => {
            // console.log(response)
            this.adminLogin._csrf = response._csrf;
            this.userService.login(this.adminLogin).subscribe((response) => {
                this.getMenu();
                if (response.token) {
                    this.router.navigateByUrl('/home');
                }
                this.spinnerService.hide();
            }, (err) => {
                if (err.status == 401) {
                    this.notifSer.error(
                        'Error',
                        err.error.message,
                        {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        }
                        )
                    } else {
                        this.notifSer.error(
                            'Error',
                            err.error.message,
                            {
                                timeOut: 3000,
                                showProgressBar: true,
                                pauseOnHover: false,
                                clickToClose: true,
                                maxLength: 50
                            }
                            )
                        }
                        this.spinnerService.hide();
                        
                    });
                }, (err) => {
                    this.notifSer.error(
                        'Error CSRF',
                        err.error.message,
                        {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        }
                    )
                });
    }

    getMenu() {
        this.adminService.getAdminPanelMenus().subscribe((success) => {
            var menulist = success.menu;
            if(menulist !== undefined)
                localStorage.setItem('permission', menulist[0].permission);
        }, (error) => {

        })
    }

    csrf() {
        this.userService.csrf().subscribe((response) => {
            // console.log(response)
            this.adminLogin._csrf = response._csrf;
        }, (err) => {
            this.notifSer.error(
                'Error CSRF',
                err.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        });
    }
    forgotpassword(){
        console.log('password');
    this.router.navigate(['forgot-password']);
        
    }

}



// WEBPACK FOOTER //
// ./src/app/applogin/applogin.component.ts